var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoliceNarrativesAiDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pnai_logo_dark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1227.4 153.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .pnai-dk0 {\n        fill: #1a75fc;\n      }\n\n      .pnai-dk1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M246.7,117.2V37.8h37.2c8.9,0,15.8,2.2,20.7,6.7,4.9,4.4,7.4,10.6,7.4,18.3s-2.5,13.8-7.4,18.3-11.8,6.7-20.6,6.7h-22.2v29.4h-15.1ZM261.7,75h21.3c4.6,0,8.1-1.1,10.4-3.2s3.6-5.1,3.6-8.9-1.2-6.8-3.6-8.9-5.9-3.2-10.4-3.2h-21.3v24.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M343.6,118.4c-6.3,0-11.8-1.3-16.4-3.8-4.7-2.5-8.3-6.1-10.9-10.7s-3.9-10-3.9-16.2,1.3-11.6,3.9-16.2,6.2-8.1,10.9-10.6c4.7-2.5,10.2-3.7,16.5-3.7s11.9,1.2,16.5,3.7,8.2,6,10.7,10.6,3.8,10,3.8,16.3-1.3,11.6-3.8,16.2c-2.6,4.6-6.1,8.2-10.8,10.6-4.6,2.5-10.2,3.7-16.6,3.7h0ZM343.7,105.7c5.2,0,9.3-1.6,12.2-4.8,2.9-3.2,4.3-7.5,4.3-13.1s-1.4-10-4.3-13.1-6.9-4.7-12.2-4.7-9.4,1.6-12.3,4.7-4.4,7.5-4.4,13,1.5,10,4.4,13.2,7,4.8,12.3,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M382.8,117.2V34.9h14.6v82.4h-14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M416.4,51.9c-2.3,0-4.2-.8-5.8-2.4-1.6-1.6-2.4-3.5-2.4-5.8s.8-4.2,2.4-5.8,3.5-2.4,5.8-2.4,4.2.8,5.8,2.4c1.6,1.6,2.4,3.5,2.4,5.8s-.8,4.2-2.4,5.8-3.5,2.4-5.8,2.4ZM409.1,117.2v-58.8h14.6v58.8h-14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M462.2,118.4c-6.1,0-11.4-1.3-16-3.8s-8.1-6.1-10.7-10.6c-2.6-4.6-3.8-10-3.8-16.2s1.3-11.6,3.8-16.2,6.1-8.1,10.6-10.6,9.9-3.8,16.1-3.8,13.9,1.9,18.8,5.7c5,3.8,8.1,9.1,9.4,15.9h-14.6c-1-2.9-2.6-5.2-4.9-6.7s-5.2-2.3-8.7-2.3-8.7,1.6-11.6,4.7-4.3,7.5-4.3,13.2,1.4,10.1,4.3,13.2,6.7,4.7,11.6,4.7c7.6,0,12.2-3.3,13.9-9.8h14.7c-1.2,7.1-4.3,12.7-9.3,16.6-5,4-11.4,5.9-19.3,5.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M523.4,118.4c-6.3,0-11.8-1.3-16.5-3.8-4.6-2.5-8.2-6.1-10.7-10.7s-3.8-10.1-3.8-16.3,1.2-11.7,3.7-16.2,6-8,10.6-10.5,9.9-3.7,16.1-3.7,11.2,1.2,15.5,3.5,7.6,5.7,10,10,3.5,9.5,3.5,15.4v5.1h-45.3c.5,5,2.2,8.8,5.1,11.4,2.9,2.6,6.8,4,11.6,4s6.5-.7,8.8-2,3.8-3.3,4.8-6h14.7c-1.4,6.2-4.5,11.1-9.5,14.6s-11.2,5.2-18.7,5.2h.1ZM506.9,81.3h31c-.6-4.1-2.2-7.1-4.7-9.3-2.6-2.1-6-3.2-10.3-3.2s-7.7,1.1-10.5,3.2c-2.7,2.2-4.6,5.2-5.5,9.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M635.6,117.2h-16.2l-43.5-58.1h-.4v58.1h-14.2V37.8h15.8l43.9,59h.4v-59h14.2v79.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M666.9,118.3c-6.9,0-12.2-1.7-16.1-5-3.9-3.3-5.8-7.7-5.8-13.2s2-10.2,5.9-13.3c4-3.1,9.7-4.7,17.1-4.7h17.9v-2.4c0-7.2-4.2-10.8-12.6-10.8s-11.3,2.5-12.8,7.6h-14.6c1.2-6.3,4.1-11.1,8.9-14.4,4.7-3.3,10.9-5,18.6-5s15.2,1.9,19.7,5.8,6.8,9.6,6.8,17v22.6h7v14.6h-15v-9.4h-4.1c-2,3.3-4.8,5.9-8.2,7.7s-7.6,2.7-12.6,2.7v.2ZM669.1,107c3.2,0,6.1-.6,8.6-1.8,2.6-1.2,4.6-2.8,6-4.9,1.5-2.1,2.2-4.4,2.2-6.9v-1.4h-17.2c-6.6,0-9.9,2.5-9.9,7.4s.9,4.3,2.7,5.6c1.8,1.3,4.3,2,7.5,2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M716.8,117.2v-44.2h-7.3v-14.6h14.9v11.4h4.1c1.6-3.9,4.2-6.9,7.6-8.9,3.4-2,7.3-3,11.7-3h4.9v12.6h-5.6c-5.3,0-9.3,1.5-11.9,4.6-2.6,3.1-4,7.2-4,12.3v30h-14.4v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M763.7,117.2v-44.2h-7.3v-14.6h14.9v11.4h4.1c1.6-3.9,4.2-6.9,7.6-8.9,3.4-2,7.3-3,11.7-3h4.9v12.6h-5.6c-5.3,0-9.3,1.5-11.9,4.6-2.6,3.1-4,7.2-4,12.3v30h-14.4v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M822.5,118.3c-6.9,0-12.2-1.7-16.1-5-3.9-3.3-5.8-7.7-5.8-13.2s2-10.2,5.9-13.3c4-3.1,9.7-4.7,17.1-4.7h17.9v-2.4c0-7.2-4.2-10.8-12.6-10.8s-11.3,2.5-12.8,7.6h-14.6c1.2-6.3,4.1-11.1,8.9-14.4,4.7-3.3,10.9-5,18.6-5s15.2,1.9,19.7,5.8,6.8,9.6,6.8,17v22.6h7v14.6h-15v-9.4h-4.1c-2,3.3-4.8,5.9-8.2,7.7-3.4,1.8-7.6,2.7-12.6,2.7v.2ZM824.7,107c3.2,0,6.1-.6,8.6-1.8,2.5-1.2,4.6-2.8,6-4.9,1.5-2.1,2.2-4.4,2.2-6.9v-1.4h-17.2c-6.6,0-9.9,2.5-9.9,7.4s.9,4.3,2.7,5.6c1.8,1.3,4.3,2,7.5,2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M887.1,117.2c-3.9,0-6.8-1-9-2.9-2.1-2-3.2-4.9-3.2-8.9v-35.6h-10.4v-11.4h10.5v-17.7h14.3v17.7h14.2v11.4h-14v36h15.4v11.5h-17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M919,51.9c-2.3,0-4.2-.8-5.8-2.4s-2.4-3.5-2.4-5.8.8-4.2,2.4-5.8c1.6-1.6,3.5-2.4,5.8-2.4s4.2.8,5.8,2.4c1.6,1.6,2.4,3.5,2.4,5.8s-.8,4.2-2.4,5.8c-1.6,1.6-3.5,2.4-5.8,2.4ZM911.7,117.2v-58.8h14.6v58.8h-14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M956.5,117.2l-25.2-58.8h15.4l17.5,42.4h.4l17.2-42.4h15l-25.2,58.8h-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M1027,118.4c-6.3,0-11.8-1.3-16.5-3.8-4.6-2.5-8.2-6.1-10.7-10.7s-3.8-10.1-3.8-16.3,1.2-11.7,3.7-16.2,6-8,10.6-10.5,9.9-3.7,16.1-3.7,11.2,1.2,15.5,3.5,7.6,5.7,10,10,3.5,9.5,3.5,15.4v5.1h-45.3c.5,5,2.2,8.8,5.1,11.4s6.8,4,11.6,4,6.5-.7,8.8-2,3.8-3.3,4.8-6h14.7c-1.4,6.2-4.5,11.1-9.5,14.6-4.9,3.5-11.2,5.2-18.7,5.2h0ZM1010.4,81.3h31c-.6-4.1-2.2-7.1-4.7-9.3-2.5-2.1-6-3.2-10.3-3.2s-7.7,1.1-10.5,3.2c-2.7,2.2-4.6,5.2-5.5,9.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M1087.9,118.4c-8.5,0-15.2-1.8-20.1-5.3-4.9-3.6-7.6-8.5-7.9-15h14.2c.5,3.1,1.9,5.3,4.2,6.8,2.4,1.5,5.8,2.2,10.2,2.2,7.5,0,11.3-2.2,11.3-6.6s-.6-3.1-1.7-4.1-3.1-1.7-5.7-2.3l-12.9-2.5c-11.5-2.2-17.3-7.6-17.3-16.3s2.2-10,6.6-13.3c4.4-3.3,10.4-5,18.1-5s13.8,1.7,18.4,5.1c4.6,3.4,7.1,8.1,7.6,14.3h-14.1c-.7-2.9-2.1-5.1-4.1-6.4s-4.9-2-8.6-2-5.9.5-7.6,1.6c-1.8,1-2.6,2.6-2.6,4.6s.6,2.7,1.7,3.6,2.9,1.6,5.3,2.1l13.2,2.6c6,1.2,10.4,3.1,13.2,5.9,2.8,2.7,4.2,6.4,4.2,11.1s-2.2,10.6-6.6,13.9-10.7,5-18.9,5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk0",
    d: "M1127.3,118.4c-2.6,0-4.7-.9-6.5-2.7s-2.7-4-2.7-6.5.9-4.7,2.7-6.5c1.8-1.8,4-2.7,6.5-2.7s4.7.9,6.5,2.7c1.8,1.8,2.7,4,2.7,6.5s-.9,4.7-2.7,6.5c-1.8,1.8-4,2.7-6.5,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M1163.7,118.3c-6.9,0-12.2-1.7-16.1-5s-5.8-7.7-5.8-13.2,2-10.2,5.9-13.3c4-3.1,9.7-4.7,17.1-4.7h17.9v-2.4c0-7.2-4.2-10.8-12.6-10.8s-11.3,2.5-12.8,7.6h-14.6c1.2-6.3,4.1-11.1,8.9-14.4,4.7-3.3,10.9-5,18.6-5s15.2,1.9,19.7,5.8,6.8,9.6,6.8,17v22.6h7v14.6h-15v-9.4h-4.1c-2,3.3-4.8,5.9-8.2,7.7s-7.6,2.7-12.6,2.7v.2ZM1165.9,107c3.2,0,6.1-.6,8.6-1.8,2.6-1.2,4.6-2.8,6-4.9,1.5-2.1,2.2-4.4,2.2-6.9v-1.4h-17.2c-6.6,0-9.9,2.5-9.9,7.4s.9,4.3,2.7,5.6c1.8,1.3,4.3,2,7.5,2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pnai-dk1",
    d: "M1219.2,51.9c-2.3,0-4.2-.8-5.8-2.4s-2.4-3.5-2.4-5.8.8-4.2,2.4-5.8,3.5-2.4,5.8-2.4,4.2.8,5.8,2.4c1.6,1.6,2.4,3.5,2.4,5.8s-.8,4.2-2.4,5.8-3.5,2.4-5.8,2.4ZM1212,117.2v-58.8h14.6v58.8h-14.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 59.3,
    y: 15.4,
    width: 12.6,
    height: 44.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 79.1,
    y: 7.9,
    width: 12.6,
    height: 29.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pnai-dk0",
    points: "98.8 27.9 98.8 31.5 111.4 31.5 111.4 27.9 111.4 0 98.8 0 98.8 27.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 138.4,
    y: 15.4,
    width: 12.6,
    height: 47.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 118.6,
    y: 7.9,
    width: 12.6,
    height: 29.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 177.9,
    y: 40.2,
    width: 12.6,
    height: 72.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pnai-dk0",
    points: "197.6 58.7 197.6 59.2 197.6 94.1 197.6 94.6 210.2 94.6 210.2 94.1 210.2 59.2 210.2 58.7 197.6 58.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 138.4,
    y: 91.7,
    width: 12.6,
    height: 46.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 118.6,
    y: 115.6,
    width: 12.6,
    height: 29.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 98.8,
    y: 121.8,
    width: 12.6,
    height: 31.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 19.8,
    y: 41,
    width: 12.6,
    height: 71.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pnai-dk0",
    points: "0 59.2 0 94.1 0 94.6 12.6 94.6 12.6 94.1 12.6 59.2 12.6 58.7 0 58.7 0 59.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 59.3,
    y: 90.8,
    width: 12.6,
    height: 47.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pnai-dk0",
    points: "39.5 65.2 39.5 122.6 52.1 122.6 52.1 65.2 52.1 30.7 39.5 30.7 39.5 65.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pnai-dk0",
    points: "158.1 50.5 158.1 65.2 158.1 122.6 170.7 122.6 170.7 65.2 170.7 50.5 170.7 30.7 158.1 30.7 158.1 50.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pnai-dk0",
    x: 79.1,
    y: 115.6,
    width: 12.6,
    height: 29.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceNarrativesAiDarkMode);
export default __webpack_public_path__ + "static/media/police-narratives-ai-dark-mode.9ffde472f059c9d24a0e1c8300b6574e.svg";
export { ForwardRef as ReactComponent };